module.exports = __webpack_public_path__ + "img/left-s.4badfb8.webp";